// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { AuditEventListItem } from '@/audit/components/audit-event-list-item';
import { getCostAuditEvents } from '@/costs/api/get-cost-audit-events';
import { Stack } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';

interface Props {
  costKey: string;
}

/**
 * Displays a vertical list of audit events for a specific cost.
 * This component suspends while fetching the audit events.
 */
export function CostAuditList({ costKey }: Props) {
  const { data } = useSuspenseQuery({
    queryKey: ['cost', costKey, 'audit'],
    queryFn: () => getCostAuditEvents(costKey),
    retry: false,
  });

  return (
    <Stack spacing={2}>
      {data.events.map((event) => (
        <AuditEventListItem key={event.id} event={event} />
      ))}
    </Stack>
  );
}
